export interface WasmExports {
  alloc_input: (size: number) => number
  run_layout: () => number
  place_labels: (
    scale: number,
    dotR: number,
    labelH: number,
    gap: number,
    maxW: number,
  ) => number
  tessellate_edges: () => number
  scene_alloc: (nodeCount: number) => void
  scene_positions: () => number
  scene_label_widths: () => number
  scene_free: () => void
  output_size: () => number
  free_all: () => void
  memory: WebAssembly.Memory
}

let exportsRef: WasmExports | null = null
let initPromise: Promise<void> | null = null
const readyCallbacks = new Set<() => void>()

export function getWasmExports(): WasmExports | null {
  if (exportsRef) return exportsRef
  ensureInit()
  return null
}

export function onWasmReady(cb: () => void) {
  readyCallbacks.add(cb)
  if (exportsRef) cb()
  return () => readyCallbacks.delete(cb)
}

export function freeWasmBuffers() {
  exportsRef?.free_all()
}

function ensureInit() {
  if (exportsRef || initPromise) return
  initPromise = initWasm().catch((err) => {
    initPromise = null
    console.error("failed to initialize layout wasm", err)
  })
}

async function initWasm() {
  const wasmUrl = new URL("/viewer/assets/layout.wasm", location.href)
  const response = await fetch(wasmUrl)
  const module = await WebAssembly.compileStreaming(response)
  const instance = await WebAssembly.instantiate(module)
  exportsRef = instance.exports as unknown as WasmExports
  for (const cb of readyCallbacks) cb()
}
